import request from '@/utils/request'

export function getMyAward(data) {
  return request({
    baseURL: '/chaos/api',
    url: '/v1/activity/my/bonus',
    method: 'get',
    params: data
  })
}

export function getActiveData(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/${data.activityId}`,
    method: 'post',
  })
}

export function getMonthRank(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/bonus/ranking`,
    method: 'get',
    params: data
  })
}

export function getMyInvite(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/bonus/my/invitation`,
    method: 'get',
    params: data
  })
}

export function sendShare() {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/bonus/send/invitation`,
    method: 'get',
  })
}

export function getWithdrawable(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/my/withdrawable-bonus`,
    method: 'get',
    params: data
  })
}

export function submitWithdraw(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/bonus/withdraw/submit`,
    method: 'get',
    params: data
  })
}


export function registerInvite(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/user/attracted`,
    method: 'post',
    data: data
  })
}

export function userWithdrawList(data) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/activity/bonus/withdraw/vibes`,
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/views/activity_42/api.js